module.exports = __webpack_public_path__ + "5cdbda56fd6b53bd98bfbed1e097f70f.MP3";